import { PLATFORM_ID, Injectable, ApplicationRef, inject } from "@angular/core";
import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { SwUpdate } from "@angular/service-worker";

import { interval } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CheckForUpdate {
  private platformId = inject(PLATFORM_ID);
  private applicationRef = inject(ApplicationRef);
  private swUpdate = inject(SwUpdate);

  private initiated = false;
  private interval = 300; // interval in second

  constructor() {
    const swUpdate = this.swUpdate;

    if (swUpdate.isEnabled) {
      if (isPlatformBrowser(this.platformId)) {
        // Client only code.
        this.checkForUpdate();
      }

      if (isPlatformServer(this.platformId)) {
        // Server only code.
        // console.log('Server : don\'t check for updated app');
      }
    }
  }

  private checkForUpdate() {
    this.applicationRef.isStable.subscribe(
      ((stable) => {
        if (this.initiated) {
          return;
        }
        if (stable) {
          // console.log('App is stable');
          interval(1000 * this.interval).subscribe(() => {
            // console.log('Check for updated app on server ');
            this.swUpdate.checkForUpdate();
          });
          this.initiated = true;
          // console.log('Update recurrent check setted');
        }
      }).bind(this),
    );
  }
}
